module.exports = __webpack_public_path__ + "img/turkiye-is-bankasi-isbox-kinect-01.8d68b283.jpg";